import { createAction, createSlice } from "@reduxjs/toolkit";
import { editingCourseActions } from "./editingCourse";

const updateLectureSlice = createSlice({
  name: "updateLecture",
  initialState: {
    data: [],
    processingList: [{ id: null, processing: false, isSuccess: null }],
  },
  reducers: {
    pending(state, action) {
      const { lectureId } = action.payload;
      state.processingList.push({
        id: lectureId,
        processing: true,
      });
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      const { lectureId } = action.payload;
      const lectureIndex = state.processingList.findIndex(
        (lecture) => lecture.id == lectureId
      );
      state.processingList[lectureIndex].processing = false;
      state.processingList[lectureIndex].isSuccess = true;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      const { lectureId } = action.payload;
      const lectureIndex = state.processingList.findIndex(
        (lecture) => lecture.id == lectureId
      );
      state.processingList[lectureIndex].processing = false;
      state.processingList[lectureIndex].isSuccess = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = updateLectureSlice;
const updateLectureAction = createAction(name);

export {
  updateLectureAction,
  actions as updateLectureActions,
  reducer as updateLectureReducer,
};
